import { render, staticRenderFns } from "./ReviewMy.vue?vue&type=template&id=c19d4b1e"
import script from "./ReviewMy.vue?vue&type=script&lang=js"
export * from "./ReviewMy.vue?vue&type=script&lang=js"
import style0 from "./ReviewMy.vue?vue&type=style&index=0&id=c19d4b1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports